import React from 'react'
import { Link } from 'react-router-dom'

import './NavButton.css'

const NavButton = ({ text, cta, path = '/' }) => {
  const className = `fmbm-navigation__button ${
    cta ? 'fmbm-navigation__button--cta' : ''
  }`

  return path.includes('http') ? (
    <a href={path} target="_blank" className={className}>
      {text}
    </a>
  ) : (
    <Link to={path} className={className}>
      {text}
    </Link>
  )
}

export default NavButton



// WEBPACK FOOTER //
// ./src/Components/NavButton/NavButton.js